import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';

export function DeclinedSubsDialog({ open, onOpenChange, position, schoolTOCs }) {
  const declinedEntries = position
    ? Object.entries(position.responses || {}).filter(
        ([_, response]) => response === 'decline' || response === 'declined_unavailable'
      )
    : [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Declined Subs</DialogTitle>
          <DialogDescription>
            The following Subs have declined this position
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {declinedEntries.length === 0 ? (
            <p className="text-sm text-slate-500 text-center py-4">No one has declined this position yet.</p>
          ) : (
            declinedEntries.map(([tocId, response]) => {
              const toc = schoolTOCs.find(t => t.user_id === tocId);
              return (
                <div key={tocId} className="flex items-center justify-between p-2 bg-slate-50 rounded">
                  <div>
                    <p className="font-medium text-slate-900">{toc?.name || 'Unknown Sub'}</p>
                    <p className="text-sm text-slate-500">{toc?.email || tocId}</p>
                  </div>
                  <Badge variant="outline" className="text-rose-600 border-rose-200">
                    {response === 'declined_unavailable' ? 'Unavailable' : 'Declined'}
                  </Badge>
                </div>
              );
            })
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
